import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-channel-fix"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "" }, [
      _createElementVNode("path", {
        d: "M26.84,37.76V35.5L24.79,33.57V21.94L26.9,21.02c0.72,0,4.73,0,5.56,0c0.83,0,1.37,0.06,1.37-0.82c0-0.88,0-11.95,0-12.9c0-0.95,0.01-1.06-0.88-1.06c-0.89,0-4.33,0.02-6.49,0V11.07c1.13-0.39,1.45-0.46,2.45-0.75c1-0.29,1.21,0.72,1.21,1.36c0,1.27,0,1.67-0.04,3.43c-0.03,1.06-0.21,1.55-1.92,1.55c-1.71,0-5.6,0.06-5.6,0.06h-0.09c0,0-3.89-0.06-5.6-0.06c-1.71,0-1.89-0.48-1.92-1.55c-0.05-1.75-0.04-2.16-0.04-3.43c0-0.64,0.21-1.65,1.21-1.36c1,0.29,1.32,0.36,2.45,0.75V6.24c-2.16,0.02-5.59,0-6.49,0c-0.9,0-0.88,0.11-0.88,1.06c0,0.95,0,11.95,0,12.9c0,0.88,0.54,0.82,1.37,0.82c0.83,0,4.84,0,5.56,0l2.11,0.92V33.57L18.19,35.5V37.76H26.8H26.84z",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M20.27,33.57H24.79",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }